export default {
  SPIN: '旋转',
  'You are not eligible for free spins':
    '只有带 CSGO 游戏并且没有被 VAC 封禁的 Steam 帐户才有资格获得免费金币。 重新登录网站以进行更新。',
  'It must be 24 hours since last roll': '距离上次转动必须已经有 24 个小时。',
};
